import { XyPixel } from '@xylabs/pixel'
import React from 'react'

interface ContextProps {
  pixel?: XyPixel
}

const ApiContext = React.createContext<ContextProps>({})
export default ApiContext
